import { api } from './client';
import { CreditBalance, CreditPack, CheckoutSession } from '../types';

export interface CreateCheckoutRequest {
  packId: string;
  successUrl: string;
  cancelUrl: string;
}

export const creditsApi = {
  /**
   * Get current user's credit balance
   */
  getBalance: async (): Promise<CreditBalance> => {
    return api.get<CreditBalance>('/v1/credits/balance');
  },

  /**
   * Get available credit packs
   */
  getPacks: async (): Promise<CreditPack[]> => {
    return api.get<CreditPack[]>('/v1/credits/packs');
  },

  /**
   * Create a Stripe checkout session for purchasing credits
   */
  createCheckout: async (
    packId: string,
    successUrl: string,
    cancelUrl: string
  ): Promise<CheckoutSession> => {
    return api.post<CheckoutSession>('/v1/credits/checkout', {
      packId,
      successUrl,
      cancelUrl,
    });
  },
};

export default creditsApi;
